<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container :disabled="formDisabled">
      <a-form-model ref="form" :model="model" :rules="validatorRules" slot="detail">
        <a-row>
          <a-col :span="24">
            <a-form-model-item label="会员卡号" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="memberCardNumber">
              <a-input v-model="model.memberCardNumber" placeholder="请输入会员卡号"  ></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item label="会员姓名" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="memberName">
              <a-input v-model="model.memberName" placeholder="请输入会员姓名"  ></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item label="会员手机号" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="mobileNumber">
              <a-input v-model="model.mobileNumber" placeholder="请输入会员手机号"  ></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item label="会员类型" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="memberType">
              <a-input-number v-model="model.memberType" placeholder="请输入会员类型" style="width: 100%" />
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item label="经纪人" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="customerManager">
              <a-input v-model="model.customerManager" placeholder="请输入经纪人"  ></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item label="微信unionId" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="unionId">
              <a-input v-model="model.unionId" placeholder="请输入微信unionId"  ></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item label="微信性别" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="userGender">
              <a-input-number v-model="model.userGender" placeholder="请输入微信性别" style="width: 100%" />
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item label="微信头像" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="userAvatarUrl">
              <a-input v-model="model.userAvatarUrl" placeholder="请输入微信头像"  ></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item label="微信所在城市" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="userCity">
              <a-input v-model="model.userCity" placeholder="请输入微信所在城市"  ></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item label="微信所在省份" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="userProvince">
              <a-input v-model="model.userProvince" placeholder="请输入微信所在省份"  ></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item label="微信所在国家" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="userCountry">
              <a-input v-model="model.userCountry" placeholder="请输入微信所在国家"  ></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item label="会员开通时间" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="memberCreateTime">
              <j-date placeholder="请选择会员开通时间" v-model="model.memberCreateTime"  style="width: 100%" />
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item label="会员到期时间" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="memberEffectiveTime">
              <j-date placeholder="请选择会员到期时间" v-model="model.memberEffectiveTime"  style="width: 100%" />
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item label="是否删除" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="isDelete">
              <a-input-number v-model="model.isDelete" placeholder="请输入是否删除" style="width: 100%" />
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </j-form-container>
  </a-spin>
</template>

<script>

  import { httpAction, getAction } from '@/api/manage'
  import { validateDuplicateValue } from '@/utils/util'

  export default {
    name: 'CtMmMemberForm',
    components: {
    },
    props: {
      //表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false
      }
    },
    data () {
      return {
        model:{
         },
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        confirmLoading: false,
        validatorRules: {
           memberType: [
              { required: true, message: '请输入会员类型!'},
           ],
           isDelete: [
              { required: true, message: '请输入是否删除!'},
           ],
        },
        url: {
          add: "/custmormember/ctMmMember/add",
          edit: "/custmormember/ctMmMember/edit",
          queryById: "/custmormember/ctMmMember/queryById"
        }
      }
    },
    computed: {
      formDisabled(){
        return this.disabled
      },
    },
    created () {
       //备份model原始值
      this.modelDefault = JSON.parse(JSON.stringify(this.model));
    },
    methods: {
      add () {
        this.edit(this.modelDefault);
      },
      edit (record) {
        this.model = Object.assign({}, record);
        this.visible = true;
      },
      submitForm () {
        const that = this;
        // 触发表单验证
        this.$refs.form.validate(valid => {
          if (valid) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.edit;
               method = 'put';
            }
            httpAction(httpurl,this.model,method).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                that.$emit('ok');
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
            })
          }
         
        })
      },
    }
  }
</script>